<template>
  <v-dialog
    content-class="dialogText"
    v-model="isDialog"
    style="z-index: 600;"
    max-width="700"
    :light="true"
  >
    <v-card v-if="isDialog">
      <div class="absX" @click.passive="cancleDialog">
        <v-icon x-large class="myGray">mdi-window-close</v-icon>
      </div>
      <div class="spacer-25"></div>
      <h3 style="padding: 0 24px" class="mt-4">Anmerkungen für {{ displayItemVol(item) }}
        {{ item.nameToDisplay }}</h3>
      <!--            <v-card-title class="headline">Anmerkungen für {{displayItemVol(item)}} {{item.nameToDisplay}}</v-card-title>-->

      <!--            v-on:submit.prevent-->
      <!--            form is required to react on virtual keyboard done event-->
      <v-card-text>
        <!--                                        <label>-->
        <!--                                            <input style="color: red" type="text" v-model="search">-->
        <!--                                        </label>-->
        <!--                    :keyup.13="doSearch"-->
        <!--                <div>Welchen Sonderwunsch hast du?</div>-->
        <div style="height: 15px"></div>
        <v-text-field
          v-model="notes"
          label="Anmerkungen"
          ref="notesInput"
          placeholder="Hier eingeben..."
          @keyup.native.enter="doProcess"
          :autofocus="true"
          hide-details
        ></v-text-field>
      </v-card-text>


      <v-card-actions>
        <v-spacer></v-spacer>

        <div class="mr-4 underline text-center">
          <span @click.passive.stop="cancleDialog" class="pointer">Abbrechen</span>
        </div>

        <!--                    <button type="submit"-->
        <!--                            style="padding: 0 16px;font-size: 14px;font-weight: 500;"-->
        <!--                            @click.prevent="doSearch">SUCHEN-->
        <!--                    </button>-->

        <v-btn
          text
          class="btn-df"
          @click.native.passive="doProcess"
        >
          OK
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import * as util from '../vendor/util'

export default {
  props: {
    dialog: Boolean,
    item: Object,
  },
  data() {
    return {
      isDialog: false,
      notes: ''
    }
  },
  // beforeCreate(){
  //     util.enableNoScroll(true)
  // },
  // beforeDestroy(){
  //     util.enableNoScroll(false)
  // },
  watch: {
    dialog(newValue) {
      this.isDialog = newValue;
      if (newValue) {
        //init
        this.notes = '' + this.item.notes;
      }
    },
    isDialog(newValue) {
      if (!newValue) {
        // this.ready = false;
        this.$emit('close');
      }
    }
  },

  methods: {
    doProcess(event) {
      this.$refs.notesInput.blur();
      this.notes = this.notes.trim();
      this.item.notes = '' + this.notes;
      // if (this.search.length > 1) {
      //     this.isDialog = false;
      //     this.$emit('verifySmsCode', this.sms);//yes
      // } else {
      this.isDialog = false;
      // }
    },
    displayItemVol(item) {
      if (item.vol.length === 0 || item.vol.toLowerCase().indexOf('standard') !== -1) {
        return '';
      } else {
        return item.vol;
      }
    },
    cancleDialog() {
      this.isDialog = false;
    }
  }
}
</script>

<style lang="scss" scoped>
/*.vvd{*/
/*    >>> .v-dialog{*/
/*        position: absolute;*/
/*    }*/
/*}*/
</style>
